import React from 'react'
import CodiceFiscaleField from '../shared/cf_field.js'
import utils from '../../modules/utils.js'
import { translateCap } from '../../modules/location.js'
import { connect } from "react-redux";
import { handleCalcCfOpen, handleCalcCfDone } from '../../modules/datalayer';
import { FiscalCodeGenerator } from "../codice_fiscale/FiscalCodeGenerator";
import { setProdotto, setFiliale, setOrario, setCapExcluded, setFlowSwitch, setDatiPersonali } from "../../actions/index";
import './toggle_container.css';
// Flow
import { skipScegliLuogo, skipDataAppuntamento } from '../../flow/flow.js';

const mapStateToProps = state => {
  return {
    flowSwitch: state.flowSwitch
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setProdotto: p => dispatch(setProdotto(p)),
    setFiliale: f => dispatch(setFiliale(f)),
    setOrario: o => dispatch(setOrario(o)),
    setCapExcluded: e => dispatch(setCapExcluded(e)),
    setFlowSwitch: (payload) => dispatch(setFlowSwitch(payload)),
    setDatiPersonali: dati => dispatch(setDatiPersonali(dati)),
  };
};

let autocomplete_timer;

class ToggleContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      value: '',
      error: ''
    }
    this.submitButton = React.createRef();

    this.handleKeyup = this.handleKeyup.bind(this);
    this.autoSubmit = this.autoSubmit.bind(this);
    this.resetToggle = this.resetToggle.bind(this);
    this.updateCode = this.updateCode.bind(this);
    this.validateSuggestion = this.validateSuggestion.bind(this);
  }

  resetToggle() {
    this.setState({
      'value': ''
    })
  }

  componentDidUpdate() {
    const props = this.props;
    
    if (this.props.flowSwitch.previousFlow && this.props.flowSwitch.goToNextStepAutomatically) {
      props.setFlowSwitch({
        goToNextStepAutomatically: false,
      })
      
      utils.simulateClick(this.submitButton.current);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forced_location !== '' && nextProps.forced_location !== this.props.forced_location && nextProps.forced_location !== this.state.value) {
      this.setState({
        'suggestions': [],
        'value': nextProps.forced_location
      });
    }
  }
  validateSuggestion(suggestion) {
    /*const { displayLines } = suggestion;

    if (Array.isArray(displayLines) && displayLines.length) {
      for (let line of displayLines) {
        if (line.toLowerCase().includes('italia')) {
          return true;
        }
      }
    }

    return false;*/
    return true;
  }
  handleKeyup() {
    let self = this;
    clearTimeout(autocomplete_timer);
    autocomplete_timer = setTimeout(function () { 
      self.props.handleKeyup();
      let value = document.getElementById("search") ? document.getElementById("search").value : "";
      self.setState({
        'suggestions': [],
        'selected_suggestion': ''
      });
      if (value.length > 3) {
        const translatedCap = translateCap(value);
        if (translatedCap!=value) {
          self.setState({
            'suggestions': [translatedCap]
          });
          return false;
        }
        let search = new window.mapkit.Search({
          language: "it",
          getsUserLocation: false,
          includePointsOfInterest: false,
          limitToCountries: "it"
        });
        search.autocomplete(value, function (err, res) {
          if (!err) {
            let sugg = [];
            let res_count = 1;
            res.results.map((obj) => {
              if (res_count < 5 && self.validateSuggestion(obj)) {
                let com1 = obj.displayLines[0] ? obj.displayLines[0].replace("Cerca nei dintorni", "") : "";
                let com2 = obj.displayLines[1] ? obj.displayLines[1].replace("Cerca nei dintorni", "") : "";
                let sugg_string = com1 + " " + com2;
                sugg.push(sugg_string)
                res_count++;
              }
            }); 
            console.log("Sugg: " + sugg)
            self.setState({
              'suggestions': sugg
            });
          }
        }, {
          'includeAddresses': true,
          'includePointsOfInterest': false
        });
      }
    }, 700)
  }

  autoSubmit(e) {
    let suggerimento = e.target.getAttribute("suggestion");
    let self = this;

    if (utils.isCapExluded(suggerimento)) {
      self.props.setProdotto(-1);

      skipScegliLuogo();
      skipDataAppuntamento();
      
      self.props.setCapExcluded(true);
    }

    this.setState({
      'suggestions': [],
      'error': '',
      'value': suggerimento
    });
  }

  handleClick = (event) => {
    event.target.focus();
  }

  handleChange = (event) => {
    let field_value = event.target.value;
    let cur_error = '';
    let correct_format = utils.validateSearch2(field_value);
    if (!correct_format) {
      cur_error = 'Formato non corretto';
    }
    this.setState({
      'value': field_value,
      'error': cur_error
    });
  }
  updateCode(cfResult) {
    handleCalcCfDone();
    this.props.setDatiPersonali({
      nome: cfResult.name,
      cognome: cfResult.surname
    });
    this.setState({
      'value': cfResult.code
    });
  }
  render() {
    let content;
    const gState = utils.getState();
    if (this.props.isOpen) {
      switch (this.props.type) {
        case 'codice fiscale':
          content = (
            <form onSubmit={this.props.handleSubmit} className={"expand " + (this.state.fiscal_code_generator_visible === true ? 'calculating' : '')}>
              <CodiceFiscaleField name="codice_fiscale" cf={this.state.value} />
              <div className="error">{this.props.errors}</div>
              {(gState.prodotto == 1) ? (<div>
                <div id="cf_composer_buttons">
                  {this.state.fiscal_code_generator_visible !== true ? (<button type="button" onClick={() => {
                    this.setState({ 'fiscal_code_generator_visible': true });
                    handleCalcCfOpen();
                  }} id="calcolatrice">
                    <img src="./img/calc.svg" /><span>Calcola Codice Fiscale</span>
                  </button>) : ''}
                </div>
                <div className={this.state.fiscal_code_generator_visible !== true ? 'hidden' : ''}>
                  <FiscalCodeGenerator onValidatedEvent={this.updateCode} />
                </div>
              </div>) : ''}
              <div id="cf-disclaimer">
                Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati personali <a href="/fissa-appuntamento/pdf/Privacy_FA_12_21.pdf" target="_blank">qui scaricabile</a>
              </div>
              <button type="submit" className="bottone">
                PROSEGUI
              </button>
            </form>);
          break;
        case 'cerca':
          let cClass = (this.state.error == '' && this.state.value != '' ? 'valid' : '') + ' ' + (this.state.error != '' && this.state.value != '' ? 'notValid' : '') + ' ' + (this.state.value != '' ? 'filled' : '')
          content = (
            <form onSubmit={this.props.handleSubmit} onKeyUp={this.handleKeyup} className="expand">
              <div className={'inputContainer ' + cClass}>
                <input type="text" name="cerca" id="search" onClick={this.handleClick} onChange={this.handleChange} value={this.state.value} autoComplete="off" />
                <label>Inserisci indirizzo e città</label>
                <div className="error">{this.props.error}</div>
                <div className="error">{this.props.erros}</div>
                <div className="error">{this.props.submiterror}</div>
                <div className="icon">
                  <img src="./img/check.png" alt="Verificato" />
                </div>
              </div>
              <div className="suggestions">
                {this.state.suggestions.map((sugg, index) => {
                  return <div key={index} suggestion={sugg} onClick={this.autoSubmit} className="suggestion">{sugg}</div>
                })}
              </div>
              <button type="submit" ref={this.submitButton} className="bottone">
                Cerca
                            </button>
            </form>);
          break;
      }
    }

    return (
      <div className="toggle-container gsap-slide" onClick={this.props.handleToggle}>
        <p className="toggle-container-title">{this.props.title}</p>
        {content}
      </div>
    );
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleContainer);



// WEBPACK FOOTER //
// ./src/components/shared/toggle_container.js